module.exports = __webpack_public_path__ + "static/loading-29813bb6796c8c12a74017173725f73e.gif";